<template>

        <li
            class="primaryNav__heading"
            @mouseenter="expand"
            @mouseleave="close"
        >
            <button
                @click="expand"
                @touchend="touch"
                @keydown.enter="enter"
                @keydown.esc="close"
                :aria-controls="id"
                aria-haspopup="true"
                :aria-expanded="isOpen"
                :class="['primaryNav__headingLink', {'-active' : isOpen}]">
                {{ heading }}
            </button>
            <transition name="primaryNav__transition">
                <section
                    :id="id"
                    v-if="isOpen"
                    v-trap="isOpen"
                    class="primaryNav__panel"
                    ref="panel"
                    @keydown="($event) => directionalHandler($event, this.$refs.panel)"
                >
                    <slot name="panel"></slot>
                </section>
            </transition>
        </li>
</template>

<script>
import trap from '@js/directives/trap'
import useDirectional from '@js/mixins/directional'
export default {
    props: {
        heading: {
            type: String,
            required: true,
        },
        link:{
            type: String,
            required: false,
            default: '#'
        },
        open: {
            type: String,
            required: true,
        },
    },
    data(){
        return {
            delayTimer: null
        }
    },
    directives: { trap },
    mixins: [useDirectional],
    computed: {
        isOpen() {
            return this.open === this.heading;
        },
        id() {
            return this.heading.toLowerCase().split(" ").join("-")
        }
    },
    methods: {
        enter(e){
            // Allows for single enter to open, double enter to go to link
            if(!this.isOpen){
                e.preventDefault()
            }
            this.expand()
        },
        // toggle() {
        //     this.$emit("toggle", this.heading);
        // },
        touch(e) {
             if(!this.isOpen){
                e.preventDefault()
            }
             this.expand()
        },
        expand(){
            this.$emit("expand", this.heading);
        },
        close(){
            this.$emit("close", this.heading);
        },
        startHover(){
            this.$emit("start", this.heading)
        },
        stopHover(){
            this.$emit("stop", this.heading)
        }
    },
};
</script>


